/* =========================================================================
   SynEra — Crème Régénérante funnel logic (quiz v3)
   Multi-screen conversion quiz (S1–S16) -> sales page.
   Screen engine: single / multi / imagecards / interstitial / qualify / results.
   Original SynEra copy on our own brand system.
   Checkout is LIVE: funnelCheckout() clears the cart, adds the variant/qty
   (+ selling plan for subscribe), applies the QUIZ discount code, and sends
   the shopper to Shopify checkout. Exit-intent email capture posts to Klaviyo.
   Quiz-step events flow to dataLayer; Meta Pixel + Shopify track commerce.
   ========================================================================= */
(function () {
  "use strict";

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var PRICE_FULL = 79.99;

  /* ===== FREE-JAR (Buy-N-Get-N-Free) offer model =====
     One-time = pay for N jars at full price, get N free (2N total) — applied by the
     funnel via the repeating "Buy 1 Get 1 Free" code. Subscribe = N jars at 10% off. */
  var FREE_JAR_CODE = "QUIZFREEJAR";                 // Shopify Buy-1-Get-1-Free (100% off, repeating, one-time)
  var SUB_FREE_CODE = "QUIZSUBFREE";                 // Subscribe first-order free jar (100% off one-time, combines w/ selling plan)
  var SUB_MULT = 0.9;                                // Subscribe & Save = 10% off (Appstle selling plan)

  // Legacy price constants — retained only for the parked custom-plan screen (renderPlan).
  var PRICE_DISC = 67.99, PRICE_TWO = 99.99, PRICE_THREE = 134.97, PRICE_SUB_FIRST = 49.99, PRICE_SUB = 71.99;
  var OFFER_CODE = "SYN15";                          // legacy — no longer applied at checkout
  var OFFER_MINUTES = 60;   // 60-minute urgency countdown on the reserved deal
  var LS = { done: "synera_done_v1", start: "synera_offer_start_v1", lead: "synera_lead_v1", answers: "synera_answers_v1" };

  var DISCOUNT = 50;        // headline promise only (Buy 1 Get 1 Free = 50% effective)
  /* ===== SHOPIFY COMMERCE WIRING ===== */
  var FUNNEL_VARIANT = 42303468568637;
  var FUNNEL_SELLING_PLAN = 2183069757;             // Appstle "Deliver every 30 days" (10% off)
  function funnelCheckout(dest) {
    dest = dest || '/checkout';
    var n = heroSel, sub = (heroMode === 'subscribe');
    if (sub) {
      // Subscribe: N jars at 10% off (Appstle selling plan) + N one-time bonus jars freed on the
      // FIRST order by QUIZSUBFREE (100% off one-time). Subscription then renews at N jars.
      try { track('add_to_cart', { paid: n, jars: 2*n, mode: 'subscribe', free: n }); } catch(e){}
      var itemsS = [ { id: FUNNEL_VARIANT, quantity: n, selling_plan: FUNNEL_SELLING_PLAN },
                     { id: FUNNEL_VARIANT, quantity: n } ];
      var fbS = '/cart/' + FUNNEL_VARIANT + ':' + n + '?selling_plan=' + FUNNEL_SELLING_PLAN;
      fetch('/cart/clear.js', { method:'POST' })
        .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:itemsS }) }); })
        .then(function(r){ if(!r.ok) throw 0; window.location.href = '/discount/' + SUB_FREE_CODE + '?redirect=' + encodeURIComponent(dest); })
        .catch(function(){ window.location.href = fbS; });
      return;
    }
    // One-time free-jar: add 2N jars, apply the repeating Buy-1-Get-1-Free code -> N free.
    var qty = 2 * n;
    try { track('add_to_cart', { paid: n, jars: qty, mode: 'onetime', free: n }); } catch(e){}
    var itemO = { id: FUNNEL_VARIANT, quantity: qty };
    var fbO = '/cart/' + FUNNEL_VARIANT + ':' + qty + '?discount=' + FREE_JAR_CODE;
    fetch('/cart/clear.js', { method:'POST' })
      .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[itemO] }) }); })
      .then(function(r){ if(!r.ok) throw 0; window.location.href = '/discount/' + FREE_JAR_CODE + '?redirect=' + encodeURIComponent(dest); })
      .catch(function(){ window.location.href = fbO; });
  }


  // Projected-improvement chart (S16). Labels are editable — set to real month names if you like.
  var CHART_MONTHS = { start: "Month 1", end: "Month 3" };

  // S15 qualify copy, keyed by the S3 "pain" answer. It speaks directly to the concern the
  // user chose (without saying "you told us"). Drafts in our hedged voice — review/finalize
  // for compliance (esp. dark circles: keep it about the delicate eye-area skin, not a cure).
  var PAIN = {
    "dark-circles": {
      heading: "Built To Brighten And Refresh The Eye Area.",
      body: "The skin around your eyes is the most delicate on your face, so it needs the gentlest touch. Niacinamide helps it look brighter and more even, while peptides and deep hydration leave the eye area looking smoother, firmer and more rested."
    },
    "texture": {
      heading: "Built To Bring Back Smooth, Even Skin.",
      body: "Uneven, dull skin is exactly what this solution is for. Peptides and deep hydration help refine the look of texture and restore a healthy, even glow."
    },
    "dryness": {
      heading: "Built To Calm And Deeply Hydrate.",
      body: "Dry, irritated skin needs comfort, not more actives fighting it. Crème Régénérante is gentle on sensitive skin and deeply hydrating, so skin feels calm and supple."
    },
    "lines": {
      heading: "The Needle-Free Way To Look Younger And Healthier.",
      body: "Those fine lines around your eyes and mouth deepen a little more with every expression — and most creams just sit on the surface. Crème Régénérante is built around VYPR-2™, a dipeptide that works beneath the skin to ease the tension where those lines form. It's the needle-free solution made to help your skin look visibly smoother, firmer and more refined — so the lines you notice most start to fade into the background. This is the one built for exactly what you came here to change."
    }
  };

  // S16 (results) LEADS with the S3 "pain" answer — the personalized outcome the shopper
  // most wants to see. Keyed by the same S3 values as PAIN. Division of labour: S15 speaks
  // to the concern in the present ("built for this"); S16 projects the 3-month OUTCOME — so
  // the two screens reinforce without repeating. Hedged, product-truth only; dark-circles
  // stays about the delicate eye-area skin (never a claim to erase dark circles).
  var RESULT = {
    "dark-circles": {
      headline: "You'll Refresh Your Tired Eyes And Have Younger And Healthier-Looking Skin In Just 3 Months With Crème Régénérante.",
      lead: "A brighter, more even, more rested-looking eye area"
    },
    "texture": {
      headline: "You'll Smooth Away Rough Texture And Have Younger And Healthier-Looking Skin In Just 3 Months With Crème Régénérante.",
      lead: "Smoother, more even, more radiant-looking texture"
    },
    "dryness": {
      headline: "You'll Relieve Dry, Tight Skin And Have Younger And Healthier-Looking Skin In Just 3 Months With Crème Régénérante.",
      lead: "Deeply hydrated skin that feels calm and comfortable"
    },
    "lines": {
      headline: "You'll Smooth Away Your Lines And Have Younger And Healthier-Looking Skin In Just 3 Months With Crème Régénérante.",
      lead: "Softer-looking fine lines, with firmer skin around them"
    }
  };

  // S4 "where do you see it most" (multi) -> a hedged, zone-specific bullet. This personalizes
  // the SECOND checkmark (the zone line) the way RESULT personalizes the first (the concern).
  // S4 is multi-select, so we lead with the highest-priority zone the shopper flagged (LOC_ORDER),
  // and drop "eyes" when S3 already leads on the eye area so the two bullets never double up.
  var LOC = {
    jawline:  "Firmer-looking skin along the jawline",
    neck:     "Firmer-looking skin along the neck",
    eyes:     "Firmer, smoother-looking skin around the eyes",
    smile:    "Softer-looking smile lines",
    forehead: "Smoother-looking skin across the forehead",
    lips:     "Smoother-looking skin around the lips"
  };
  var LOC_ORDER = ["jawline", "neck", "eyes", "smile", "forehead", "lips"];
  // Returns the zone bullet for the top-priority location picked, or null (keep the generic line).
  function zoneBullet() {
    var picked = Array.isArray(answers.location) ? answers.location : [];
    if (!picked.length) return null;
    var order = leadPain() === "dark-circles" ? LOC_ORDER.filter(function (z) { return z !== "eyes"; }) : LOC_ORDER;
    for (var i = 0; i < order.length; i++) if (picked.indexOf(order[i]) !== -1) return LOC[order[i]];
    return null;
  }
  // S3 "pain" is multi-select — collapse the picked concerns to a single "lead" concern
  // (fixed priority) for the PAIN/RESULT maps, which key on one value. Handles string or array.
  var PAIN_ORDER = ["lines", "dark-circles", "texture", "dryness"];
  function leadPain() {
    var p = answers.pain;
    if (Array.isArray(p)) {
      for (var i = 0; i < PAIN_ORDER.length; i++) if (p.indexOf(PAIN_ORDER[i]) !== -1) return PAIN_ORDER[i];
      return p[0] || null;
    }
    return p || null;
  }

  var money = function (n) { return "$" + n.toFixed(2); };
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function scrollBehavior() { return REDUCED ? "auto" : "smooth"; }

  /* ---------- analytics: one event layer, ready for GA4 / Meta / Klaviyo ---
     Connect later by loading gtag/fbq/klaviyo; events already flow to dataLayer. */
  function track(name, props) {
    props = props || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "synera_" + name }, props));
      if (typeof window.gtag === "function") window.gtag("event", name, props);
      if (typeof window.fbq === "function") window.fbq("trackCustom", name, props);
      if (typeof window._learnq !== "undefined" && window._learnq.push) window._learnq.push(["track", name, props]);
    } catch (e) {}
    if (window.SYNERA_DEBUG) console.log("[track]", name, props);
  }

  /* =======================================================================
     QUIZ CONTENT — screen config (easy to edit / reorder / extend)
     Each screen object:
       id        : unique key — the answer is stored on `answers[id]`
       type      : 'single'      choose one (taps auto-advance; set `continue:true` to require Continue)
                   'multi'       choose one or more  (Continue enabled at >=1)
                   'imagecards'  multi, rendered as image-placeholder cards
                   'reassurance' message + image-slider carousel + manual Continue (S5)
                   'interstitial' loading message that AUTO-ADVANCES (`auto:true`) after ~3s (S7/S9/S12)
                   'qualify'     confirmation / qualifier slide with Continue (S15)
                   'results'     payoff slide (headline + coded chart + CTA)
       prompt/headline/subline/options/... per type (see renderers below)

     CHECKPOINT BUILD: this array holds ONE of each component type to lock the look —
     S1 (single tap-through + skip), S2 (multi), S4 (image cards), S5 (reassurance + slider),
     S7 (auto-advance loading interstitial), S16 (results). After sign-off, populate the
     remaining S3/S6/S8–S15 using the same components. Full roadmap is at the array's end.
     ===================================================================== */
  var SCREENS = [

    /* S1 — INTRO + AGE (single). Promo headline sits above the first question;
       low-emphasis Skip below the options. */
    { id: "age", type: "single",
      headline: 'Take This 1-Minute Quiz for a <span class="qz-ul">Free Jar</span> of Our Most Advanced Firming Peptide Cream',
      prompt: "What Age Are You & Your Skin?",
      skip: true,
      options: [
        { value: "under-30", label: "Under 30" },
        { value: "30-40",    label: "30–40" },
        { value: "41-50",    label: "41–50" },
        { value: "51-60",    label: "51–60" },
        { value: "over-60",  label: "Over 60" }
      ] },

    /* S2 — CONCERN (multi). */
    { id: "concern", type: "multi",
      prompt: "What's Frustrating You Most?",
      subline: "Choose whatever skin issues you have.",
      options: [
        { value: "fine-lines",  label: "Fine lines" },
        { value: "expression",  label: "Expression lines" },
        { value: "firmness",    label: "Loss of firmness" },
        { value: "sagging",     label: "Sagging around the jaw & neck" },
        { value: "texture",     label: "Uneven texture" },
        { value: "dryness",     label: "Dryness" }
      ] },

    /* S3 — CONCERNS (multi-select image cards). "What do you wish to go away" — tap all that
       apply; each option carries a photo. The picked concerns collapse to one lead concern
       (leadPain, fixed priority) that drives the S13 qualify (PAIN map) + the S14 personalized
       result (RESULT map). Replaces the old separate text-concern + zone-grid pair. */
    { id: "pain", type: "imagecards",
      prompt: "What Do You Wish To Go Away?",
      subline: "Tap all that apply.",
      options: [
        { value: "dark-circles", label: "The tired look around my eyes", img: (window.FUNNEL_ASSET_BASE+"funnel-quiz-pain-eyes.jpg") },
        { value: "texture",      label: "Dull, uneven-looking skin",      img: (window.FUNNEL_ASSET_BASE+"funnel-quiz-pain-dull.jpg") },
        { value: "dryness",      label: "Dry, tight, uncomfortable skin", img: (window.FUNNEL_ASSET_BASE+"funnel-quiz-pain-dry.jpg") },
        { value: "lines",        label: "Fine lines and wrinkles",        img: (window.FUNNEL_ASSET_BASE+"funnel-quiz-pain-lines.jpg") }
      ] },

    /* S5 — REASSURANCE + IMAGE SLIDER (manual Continue). */
    { id: "reassure-not-alone", type: "reassurance",
      heading: "You're Right Where You Should Be.",
      // Founder quote (founder's own words, compliance-hedged). Confirm final wording with her.
      quote: "I spent years and a lot of money on treatments that never gave me what I wanted, so I built it myself. My Crème Régénérante instantly hydrates and brightens, softens the look of fine lines, and helps delay how new ones form. Now it's the one thing I trust to keep my skin looking firm and younger, for longer.",
      quoteBy: "Founder, age 43",
      rating: { value: "4.8", caption: "verified reviews" },   // matches the sales-page rating
      video: (window.FUNNEL_ASSET_BASE+"funnel-quiz-reassure.mp4"),
      poster: (window.FUNNEL_ASSET_BASE+"funnel-quiz-reassure-poster.jpg"),
      videoBA: { at: 3.8, before: "Before", after: "After" },   // label flips to "After" when the cream meets the face (~3.8s)
      videoCaption: "Video of the founder using the cream",
      cta: "Continue" },

    /* S6 — PRODUCTS TRIED (multi). */
    { id: "tried", type: "multi",
      prompt: "Which Firming Products Have You Already Tried?",
      subline: "Select all that apply.",
      options: [
        { value: "creams",       label: "Firming creams" },
        { value: "serums",       label: "Serums" },
        { value: "moisturizers", label: "Moisturizers" },
        { value: "retinol",      label: "Retinol" },
        { value: "ha",           label: "Hyaluronic acid" },
        { value: "collagen",     label: "Collagen" },
        { value: "none",         label: "Haven't tried any", exclusive: true }
      ] },

    /* S7 — LOADING INTERSTITIAL (auto-advance). */
    { id: "int-not-your-fault", type: "interstitial", auto: true,
      heading: "It's Okay If Nothing Has Worked So Far.",
      body: "Most creams just sit on the surface. Crème Régénérante <b>works deeper</b> — its VYPR-2™ peptide is clinically shown to <b>reduce wrinkle depth by 52% in 28 days</b>.",
      note: "Ingredient study: Dipeptide Diaminobutyroyl Benzylamide Diacetate, 28 days, DSM/Pentapharm, n=15." },

    /* S8 — TREATMENTS HAD (multi). */
    { id: "treatments", type: "multi",
      prompt: "Have You Gotten Any Of These Treatments?",
      subline: "Select all that apply.",
      options: [
        { value: "botox",         label: "Botox" },
        { value: "fillers",       label: "Fillers" },
        { value: "microneedling", label: "Microneedling" },
        { value: "laser",         label: "Laser resurfacing" },
        { value: "rf",            label: "Radiofrequency" },
        { value: "other",         label: "Something else" },
        { value: "none",          label: "No, none of these", exclusive: true }
      ] },

    /* S9 — LOADING INTERSTITIAL (auto-advance). */
    { id: "int-not-necessary", type: "interstitial", auto: true,
      heading: "You Don't Always Need Those Treatments.",
      body: "Injectables are <b>costly and invasive</b> — about <b>$435 a session</b> for Botox, <b>$715 a syringe</b> for fillers. A needle-free peptide solution is the gentler route, at home on your own time.",
      note: "Average U.S. physician fees, American Society of Plastic Surgeons." },

    /* S10 — DESIRED OUTCOME (multi). */
    { id: "outcome", type: "multi",
      prompt: "What Would Firmer, Smoother Skin Mean For You?",
      subline: "Pick as many as you like.",
      options: [
        { value: "younger",    label: "Looking years younger" },
        { value: "confidence", label: "Confidence without makeup" },
        { value: "firmness",   label: "Firmness & elasticity restored" },
        { value: "smoother",   label: "Smoother, tighter-looking skin" },
        { value: "self",       label: "Less self-consciousness" },
        { value: "all",        label: "All of the above", all: true }
      ] },

    /* S11 — TIME PER DAY (single, manual Continue). */
    { id: "time", type: "single", continue: true,
      prompt: "How Much Time Do You Have For Skincare Daily?",
      options: [
        { value: "unsure", label: "I'm not sure" },
        { value: "5",      label: "5 Minutes" },
        { value: "10",     label: "10 Minutes" },
        { value: "20",     label: "20 Minutes" },
        { value: "30plus", label: "30+ Minutes" },
        { value: "none",   label: "I don't have time every day" }
      ] },

    /* S11b — BUSY REASSURANCE (auto-advance loading interstitial). Follows the "time per day"
       question to reassure a time-pressed shopper that the ritual fits a busy life. Reworded
       to product truth (pea-size, AM/PM ritual) with hedged, appearance-based claims. */
    { id: "int-busy", type: "interstitial", auto: true,
      heading: "Being Busy Won't Hold Your Skin Back.",
      body: "With Crème Régénérante, just a couple of minutes a day is all it takes to smooth and plump the look of thinning, crepey skin." },

    /* S11c — SKIN TONE (single, manual Continue). Coded swatch chips lead each label
       (engine renders o.swatch via .qz-opt__swatch). Personalization/engagement only. */
    { id: "tone", type: "single", continue: true,
      prompt: "What's Your Skin Tone?",
      subline: "This helps us picture your results.",
      options: [
        { value: "very-light", label: "Very Light", swatch: "#F2D6C2" },
        { value: "light",      label: "Light",      swatch: "#E7BE9B" },
        { value: "medium",     label: "Medium",     swatch: "#CE9E72" },
        { value: "tan",        label: "Tan",        swatch: "#875530" },
        { value: "dark",       label: "Dark",       swatch: "#5E3A22" },
        { value: "very-dark",  label: "Very Dark",  swatch: "#3A2416" }
      ] },

    /* S12 — SENSITIVE SKIN (single, manual Continue). */
    { id: "sensitive", type: "single", continue: true,
      prompt: "Is Your Skin Sensitive?",
      options: [
        { value: "yes",       label: "Yes" },
        { value: "no",        label: "No" },
        { value: "sometimes", label: "Sometimes" }
      ] },

    /* S13b — ANALYZING (auto-advance loading interstitial). A quick "reading your answers /
       checking your discount" beat that builds straight into the qualify match screen. */
    { id: "int-analyzing", type: "interstitial", auto: true, delay: 1400,   // quick flash, not a full read
      heading: "Analyzing Your Answers…",
      body: "We are making sure that our solution is right for you.",
      prep: "Almost there…" },

    /* S13 — QUALIFY (confirmation slide + Continue). Heading/body pull from the S3 "pain" answer.
       Social-proof constellation of real faces (center + 8 orbiting) replaces the product jar. */
    { id: "qualify", type: "qualify",
      kicker: "Congratulations — you qualify for a free jar.",
      heading: "Our Advanced Peptide Firming Cream Is A Perfect Match For Your Particular Skin Type.",
      useMarquee: true,   // creative alt to the radar; flip to false to restore socialConstellation()
      constellation: {
        center: (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-center.jpg"),
        // order maps to the POS[] layout in socialConstellation(); av9/av10 (deeper skin
        // tones) sit in the two larger prominent slots (index 2 and 6).
        orbit: [
          (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av1.jpg"),  (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av2.jpg"),
          (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av9.jpg"),  (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av3.jpg"),
          (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av4.jpg"),  (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av5.jpg"),
          (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av10.jpg"), (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av6.jpg"),
          (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av7.jpg"),  (window.FUNNEL_ASSET_BASE+"funnel-quiz-social-av8.jpg")
        ]
      } },

    /* S14 — RESULTS / PAYOFF (promise headline + risk-reversal subcopy + real-month chart + offer). */
    { id: "results", type: "results",
      lead: "Based On Everything You Told Us",
      // Fallback promise headline (RESULT[pain] overrides it per concern).
      headline: "We predict that you will have visibly younger and healthier looking skin in just 3 months with Crème Régénérante™",
      // Close copy of the reference's two lines with only the needed swaps: "guarantee you'll achieve
      // remarkable results" → "confident you'll love your results" (no efficacy guarantee). NOTE: "pay
      // nothing for your 3-month supply" implies a full-plan (≈90-day) refund — confirm the policy.
      subcopy: "<p>And because you’ve qualified through the quiz, we’re confident you’ll love your results with our advanced peptide firming cream.</p>" +
               "<p>If not, you’ll <span class=\"u\">get all your money back</span> — you pay nothing if you aren’t happy in the first 30 days.</p>",
      cta: "Claim My Free Jar" }

    /* S15 — CUSTOM PLAN (PARKED 2026-07-08 — built + working, set aside per operator to revisit).
       To re-enable: uncomment this entry AND repoint the results email-gate handlers (claimDiscount
       + skip) from revealSite() back to nextScreen(). renderPlan(), its CSS, and PRICE_THREE are kept. */
    // { id: "plan", type: "plan",
    //   lead: "Your Custom Plan",
    //   headline: "Your 3-Month Plan For Firmer, Smoother-Looking Skin",  // fallback; RESULT[pain] overrides
    //   cta: "Start My Plan" }

    /* ── 16 SCREENS — flow runs in array order ───────────────────────────────
       age · concern · pain(images) · reassure(founder) · tried · int-not-your-fault ·
       treatments · int-not-necessary · outcome · time · int-busy · tone · sensitive ·
       int-analyzing · qualify · results.  (Re-added 2026-07-09: the "busy" interstitial after
       the time question + the skin-tone Q; plus an "analyzing" loader before qualify.)
       Progress bar auto-scales to SCREENS.length. ──────────────────────────────── */
  ];

  /* ---------- state ----------------------------------------------------- */
  var answers = {};
  var screenIndex = 0;
  var advanceT = null;                // pending auto-advance timer
  var offerActive = false;
  var timerInt = null;

  var stage = $("#qStage");
  var prog  = $("#qProgress");

  function setProgress(pct) {
    pct = Math.max(0, Math.min(100, pct));
    prog.style.width = pct + "%";
    var bar = prog.parentElement; if (bar) bar.setAttribute("aria-valuenow", Math.round(pct));
  }
  function pctFor(i) { return ((i + 1) / SCREENS.length) * 100; }

  /* ---------- screen router --------------------------------------------- */
  function renderScreen(i) {
    clearTimeout(advanceT);
    var S = SCREENS[i];
    if (!S) return;
    screenIndex = i;
    if (S.type === "reassurance") return renderReassurance(S, i);
    if (S.type === "interstitial" || S.type === "qualify") return renderInterstitial(S, i);
    if (S.type === "results") return renderResults(S, i);
    if (S.type === "plan") return renderPlan(S, i);
    return renderSelect(S, i);   // single | multi | imagecards
  }

  function nextScreen() {
    clearTimeout(advanceT);
    if (screenIndex < SCREENS.length - 1) renderScreen(screenIndex + 1);
    // the final screen (results) exits via its own CTA — see claimDiscount()
  }
  function prevScreen() {
    clearTimeout(advanceT);
    if (screenIndex <= 0) return;
    // Skip back OVER auto-advancing loading interstitials — otherwise landing on one just
    // bounces the user forward again, so Back appears to do nothing.
    var i = screenIndex - 1;
    while (i > 0 && SCREENS[i].type === "interstitial" && SCREENS[i].auto) i--;
    renderScreen(i);
  }

  /* ---------- selection screens (single / multi / image cards) ---------- */
  function renderSelect(S, i) {
    var cards  = S.type === "imagecards";
    var single = S.type === "single" || (cards && S.single === true);
    var multi  = !single;                 // multi allows many; single (incl. single image cards) picks one
    setProgress(pctFor(i));

    var stored = answers[S.id];
    var chosen = multi ? (Array.isArray(stored) ? stored.slice() : []) : (stored || null);
    function valid() { return multi ? chosen.length > 0 : !!chosen; }

    var html = '<div class="qz qz--' + (cards ? "cards" : "select") + ' fade-step">';
    if (S.headline) html += '<h1 class="qz__promo">' + S.headline + '</h1>';
    html += '<div class="qz__head">';
    // one h1 per screen: the promo owns it when present (S1), otherwise the prompt does
    var pTag = S.headline ? "h2" : "h1";
    html += '<' + pTag + ' class="qz__prompt" id="qzPrompt">' + S.prompt + '</' + pTag + '>';
    var sub = S.subline || (multi ? "Choose all that apply." : "");
    if (sub) html += '<p class="qz__sub">' + sub + '</p>';
    html += '</div>';

    var selAttr = multi ? "aria-pressed" : "aria-checked";
    // roving tabindex for the single-select radio pattern: the checked radio (or the first,
    // if none) is the single tab stop; arrow keys move between the rest.
    var rovingIdx = 0;
    if (single) S.options.forEach(function (o, k) { if (o.value === chosen) rovingIdx = k; });
    html += '<div class="' + (cards ? "qz-cards" : "qz-opts") + '" role="' + (multi ? "group" : "radiogroup") + '" aria-labelledby="qzPrompt">';
    S.options.forEach(function (o, idx) {
      var on = multi ? (chosen.indexOf(o.value) !== -1) : (chosen === o.value);
      var ti = single ? (' tabindex="' + (idx === rovingIdx ? "0" : "-1") + '"') : "";
      if (cards) {
        html += '<button type="button" class="qz-card' + (on ? " is-on" : "") + '"' + (single ? ' role="radio"' : '') + ti +
                ' data-v="' + o.value + '" ' + selAttr + '="' + (on ? "true" : "false") + '">';
        if (o.img) {
          html += '<span class="qz-card__media"><img src="' + o.img + '" alt="" loading="lazy" /></span>';
        } else {
          // placeholder (decorative) — the visible label below names the choice
          html += '<span class="ph ph--card" aria-hidden="true">' +
                    '<span class="ph__tag">Image</span>' +
                    '<span class="ph__cap">' + o.label + '</span></span>';
        }
        html += '<span class="qz-card__label">' + o.label + '</span>';
        html += '<span class="qz-card__tick" aria-hidden="true"></span>';
        html += '</button>';
      } else {
        html += '<button type="button" class="qz-opt' + (on ? " is-on" : "") + '"' + (single ? ' role="radio"' : '') + ti +
                ' data-v="' + o.value + '" ' + selAttr + '="' + (on ? "true" : "false") + '">';
        html += '<span class="qz-opt__label">' +
                (o.swatch ? '<span class="qz-opt__swatch" style="background:' + o.swatch + '" aria-hidden="true"></span>' : '') +
                o.label + '</span>';
        html += '<span class="qz-opt__tick" aria-hidden="true"></span>';
        html += '</button>';
      }
    });
    html += '</div>';

    if (S.skip) html += '<button type="button" class="qz-skip" id="qzSkip">Skip this quiz</button>';

    // single screens tap through by default; `continue:true` shows a Continue instead
    var showContinue = multi || (single && !!S.continue);
    html += '<div class="qz-nav">';
    if (i > 0) html += '<button type="button" class="qz-back"><span aria-hidden="true">&larr;</span> Back</button>';
    if (showContinue) html += '<button type="button" class="btn btn--lg qz-cont"' + (valid() ? "" : " disabled") + '>' +
                       'Continue <span class="arr" aria-hidden="true">&rarr;</span></button>';
    html += '</div>';
    html += '</div>';
    stage.innerHTML = html;

    var optSel = cards ? ".qz-card" : ".qz-opt";
    var cont = $(".qz-cont", stage);
    function sync() { if (cont) cont.disabled = !valid(); }

    var opts = $$(optSel, stage);

    if (multi) {
      // option metadata lookup — supports `exclusive` ("None of these") + an `all` (select-all) option
      var optMeta = function (v) { var m = null; S.options.forEach(function (o) { if (o.value === v) m = o; }); return m; };
      var allOpt = null; S.options.forEach(function (o) { if (o.all) allOpt = o; });
      var syncMulti = function () {
        opts.forEach(function (b) {
          var on = chosen.indexOf(b.getAttribute("data-v")) !== -1;
          b.classList.toggle("is-on", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
      };
      opts.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var v = btn.getAttribute("data-v"), m = optMeta(v);
          var isOn = chosen.indexOf(v) !== -1;
          if (m && m.all) {
            // "All of the above": select every non-exclusive option (incl. itself), or clear all
            chosen = isOn ? [] : S.options.filter(function (o) { return !o.exclusive; }).map(function (o) { return o.value; });
          } else if (m && m.exclusive) {
            // a "None" option is mutually exclusive with everything else
            chosen = isOn ? [] : [v];
          } else {
            if (isOn) chosen.splice(chosen.indexOf(v), 1); else chosen.push(v);
            // any normal change clears an exclusive "None", then reconciles the "all" flag
            chosen = chosen.filter(function (val) { var mm = optMeta(val); return !(mm && mm.exclusive); });
            if (allOpt) {
              var reals = S.options.filter(function (o) { return !o.all && !o.exclusive; }).map(function (o) { return o.value; });
              var haveAll = reals.every(function (val) { return chosen.indexOf(val) !== -1; });
              var ai = chosen.indexOf(allOpt.value);
              if (haveAll && ai === -1) chosen.push(allOpt.value);
              else if (!haveAll && ai !== -1) chosen.splice(ai, 1);
            }
          }
          answers[S.id] = chosen.slice();
          syncMulti();
          sync();
        });
      });
    } else {
      // single-select ARIA radio pattern: roving tabindex + arrow keys. A click/Enter/Space
      // confirms and auto-advances; arrow keys move focus + select without advancing.
      var selectOne = function (btn, advance) {
        chosen = btn.getAttribute("data-v"); answers[S.id] = chosen;
        opts.forEach(function (b) {
          var bon = b === btn;
          b.classList.toggle("is-on", bon);
          b.setAttribute("aria-checked", bon ? "true" : "false");
          b.tabIndex = bon ? 0 : -1;
        });
        if (advance) {
          track("quiz_answer", { id: S.id, type: S.type, value: chosen });
          clearTimeout(advanceT);
          advanceT = window.setTimeout(nextScreen, REDUCED ? 90 : 280);
        }
      };
      var tapAdvance = !S.continue;   // false when the screen uses an explicit Continue
      opts.forEach(function (btn) {
        btn.addEventListener("click", function () { selectOne(btn, tapAdvance); sync(); });
        btn.addEventListener("keydown", function (e) {
          var idx = opts.indexOf(btn), n = opts.length, t = null;
          if (e.key === "ArrowDown" || e.key === "ArrowRight") t = opts[(idx + 1) % n];
          else if (e.key === "ArrowUp" || e.key === "ArrowLeft") t = opts[(idx - 1 + n) % n];
          else if (e.key === "Home") t = opts[0];
          else if (e.key === "End") t = opts[n - 1];
          if (t) { e.preventDefault(); t.focus({ preventScroll: true }); selectOne(t, false); sync(); }
        });
      });
    }

    if (cont) cont.addEventListener("click", function () {
      if (!valid()) return;
      track("quiz_answer", { id: S.id, type: S.type });
      nextScreen();
    });

    var back = $(".qz-back", stage); if (back) back.addEventListener("click", prevScreen);
    var skip = $("#qzSkip", stage);
    if (skip) skip.addEventListener("click", function () {
      track("quiz_skip", { via: "intro" });
      // TODO(route): confirm where a skip should land. For now, continue the funnel
      // to the existing sales page (no discount applied — reward logic is out of scope).
      showSiteDirect(false);
    });

    // focus the active option (the roving radio for single; the first for multi/cards)
    var focusTarget = single ? (opts[rovingIdx] || opts[0]) : opts[0];
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  /* ---------- reassurance slide (message + image-slider carousel) ------- */
  function renderReassurance(S, i) {
    setProgress(pctFor(i));
    var slides = S.slides || [];
    var html = '<div class="qz qz--reassure fade-step">';
    html += '<h1 class="qz__int-h">' + S.heading + '</h1>';
    if (S.quote) {
      html += '<blockquote class="qz-reassure__quote">“' + S.quote + '”</blockquote>';
      if (S.quoteBy) html += '<p class="qz-reassure__by">' + S.quoteBy + '</p>';
    }
    if (S.body) html += '<p class="qz__int-body">' + S.body + '</p>';
    if (S.note) html += '<p class="qz__note">' + S.note + '</p>';   // citation / footnote

    if (S.rating) {
      var star = '<svg class="qz-star" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2l2.95 6.16 6.75.72-5.02 4.55 1.38 6.65L12 17.9l-6.04 3.38 1.38-6.65L2.3 9.08l6.75-.72z"/></svg>';
      html += '<div class="qz-stars">' +
                '<span class="qz-stars__row" role="img" aria-label="Rated ' + S.rating.value + ' out of 5 stars">' +
                  star + star + star + star + star +
                  '<span class="qz-stars__num">' + S.rating.value + '</span></span>' +
                (S.rating.caption ? '<span class="qz-stars__cap">' + S.rating.caption + '</span>' : '') +
              '</div>';
    }

    if (S.video) {
      // single reassurance clip — ambient ritual b-roll, autoplays muted + loops (no controls)
      html += '<div class="qz-reassure__video">';
      html += '<video class="qz-reassure__vid" autoplay muted loop playsinline preload="auto"' +
              (S.poster ? ' poster="' + S.poster + '"' : '') + '>' +
                '<source src="' + S.video + '" type="video/mp4" />' +
              '</video>';
      if (S.videoBA) html += '<span class="qz-reassure__ba" data-state="before">' + (S.videoBA.before || "Before") + '</span>';
      html += '</div>';
      if (S.videoCaption) html += '<p class="qz-reassure__vcap">' + S.videoCaption + '</p>';
    } else {
      html += '<div class="qz-slider">';
      html += '<div class="qz-slider__track" id="qzSlides" tabindex="0" role="group" aria-label="Gallery, scroll to browse">';
      slides.forEach(function (s, k) {
        var cap = (typeof s === "string") ? s : (s.cap || "");
        var img = (typeof s === "string") ? null : s.img;
        html += '<figure class="qz-slide">';
        if (img) {
          html += '<span class="qz-slide__media"><img src="' + img + '" alt="' + cap + '" loading="lazy" /></span>';
        } else {
          html += '<span class="ph ph--slide" aria-hidden="true">' +
                    '<span class="ph__tag">Image ' + (k + 1) + '</span>' +
                    '<span class="ph__cap">' + cap + '</span></span>';
        }
        html += '</figure>';
      });
      html += '</div>';   // track
      if (slides.length > 1) {
        html += '<div class="qz-slider__dots">';
        slides.forEach(function (cap, k) {
          html += '<button type="button" class="qz-dot' + (k === 0 ? " is-on" : "") + '" data-k="' + k +
                  '" aria-label="Show slide ' + (k + 1) + ' of ' + slides.length + '"></button>';
        });
        html += '</div>';
      }
      html += '</div>';   // slider
    }

    html += '<div class="qz-nav">';
    if (i > 0) html += '<button type="button" class="qz-back"><span aria-hidden="true">&larr;</span> Back</button>';
    html += '<button type="button" class="btn btn--lg qz-cont">' + (S.cta || "Continue") +
            ' <span class="arr" aria-hidden="true">&rarr;</span></button>';
    html += '</div>';
    html += '</div>';
    stage.innerHTML = html;

    // before/after label overlay on the reassurance video (flips at S.videoBA.at seconds, resets each loop)
    if (S.videoBA) {
      var rvid = $(".qz-reassure__vid", stage);
      var baTag = $(".qz-reassure__ba", stage);
      if (rvid && baTag) {
        var baAt = S.videoBA.at || 0, baLast = null;
        rvid.addEventListener("timeupdate", function () {
          var st = rvid.currentTime >= baAt ? "after" : "before";
          if (st === baLast) return;
          baLast = st;
          baTag.textContent = st === "after" ? (S.videoBA.after || "After") : (S.videoBA.before || "Before");
          baTag.setAttribute("data-state", st);
        });
      }
    }

    var track = $("#qzSlides", stage);
    var dots = $$(".qz-dot", stage);
    function setActive(k) {
      dots.forEach(function (d, di) {
        var on = di === k;
        d.classList.toggle("is-on", on);
        if (on) d.setAttribute("aria-current", "true"); else d.removeAttribute("aria-current");
      });
    }
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        var k = parseInt(d.getAttribute("data-k"), 10);
        var slide = track.children[k];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: REDUCED ? "auto" : "smooth" });
        setActive(k);
      });
    });
    if (track && dots.length) {
      track.addEventListener("scroll", function () {
        var k = Math.round(track.scrollLeft / (track.clientWidth || 1));
        setActive(Math.max(0, Math.min(dots.length - 1, k)));
      }, { passive: true });
    }

    var cont = $(".qz-cont", stage);
    if (cont) { cont.addEventListener("click", nextScreen); cont.focus({ preventScroll: true }); }
    var back = $(".qz-back", stage); if (back) back.addEventListener("click", prevScreen);
  }

  /* qualify-screen social proof: a deliberately ASYMMETRIC cluster of real faces on a 300px
     canvas — varied avatar sizes + hand-placed positions [x, y, size] so it reads organic,
     not a clock-face ring. Two dashed rings sit behind as a decorative orbit motif. The
     center face is largest; the 10 orbiting slots are filled from c.orbit in order. */
  function socialConstellation(c) {
    // [x, y, diameter] centre of each orbiting avatar within the 340×340 box.
    // Hand-placed for an ORGANIC, WIDELY-SPACED scatter: every avatar a different size
    // (34–70px), each pushed out to a large, irregular distance/angle from centre so the
    // cluster breathes and never reads as an even clock-face. (Slots 2 & 6 = av9/av10, the
    // deeper skin tones — kept prominent on the outer band.)
    var POS = [
      [124,  43, 70], [256,  47, 36], [308, 146, 58], [281, 263, 50], [196, 318, 40],
      [ 34, 220, 44], [104, 294, 62], [ 38, 122, 52], [195,  78, 34], [ 99,  99, 48]
    ];
    var h = '<div class="qz-constel" role="img" aria-label="Women Crème Régénérante is made for">';
    h += '<span class="qz-constel__ring qz-constel__ring--x" aria-hidden="true"></span>';
    h += '<span class="qz-constel__ring qz-constel__ring--o" aria-hidden="true"></span>';
    h += '<span class="qz-constel__ring qz-constel__ring--i" aria-hidden="true"></span>';
    h += '<img class="qz-constel__av qz-constel__av--c" src="' + c.center + '" alt="" ' +
         'style="--d:90px;left:170px;top:170px" />';
    for (var k = 0; k < c.orbit.length && k < POS.length; k++) {
      var p = POS[k];
      h += '<img class="qz-constel__av" src="' + c.orbit[k] + '" alt="" ' +
           'style="--d:' + p[2] + 'px;left:' + p[0] + 'px;top:' + p[1] + 'px" />';
    }
    h += '</div>';
    if (c.caption) h += '<p class="qz-constel__cap">' + c.caption + '</p>';
    return h;
  }

  /* Alternative to the radar constellation: a calm two-row "wall of faces" that gently drifts in
     opposite directions with the edges fading out. Reads as "real people like you," and it is
     robust (no hand-placed geometry). Toggled per-screen via S.useMarquee; reuses constellation data. */
  function facesMarquee(c) {
    var all = [c.center].concat(c.orbit || []);
    var rowFor = function (parity, dir) {
      var imgs = all.filter(function (_, i) { return i % 2 === parity; })
        .map(function (src) { return '<img class="qz-marq__face" src="' + src + '" alt="" loading="lazy" />'; }).join('');
      return '<div class="qz-marq__row"><div class="qz-marq__track qz-marq__track--' + dir + '">' + imgs + imgs + '</div></div>';
    };
    return '<div class="qz-marq" role="img" aria-label="Real people Crème Régénérante is made for">' +
             rowFor(0, 'l') + rowFor(1, 'r') +
           '</div>';
  }

  /* ---------- interstitial / qualify slides ----------------------------- */
  function renderInterstitial(S, i) {
    setProgress(pctFor(i));
    var auto = !!S.auto;
    var qualify = S.type === "qualify";

    // qualify (S15) speaks back to the S3 "pain" answer, without saying "you told us"
    var heading = S.heading, body = S.body;
    var lp = leadPain(); if (S.painDriven && PAIN[lp]) { body = PAIN[lp].body; }   // keep the fixed "match" heading; personalize only the body

    var html = '<div class="qz qz--int fade-step">';
    if (qualify && S.kicker) html += '<p class="qz__lead">' + S.kicker + '</p>';
    html += '<div class="qz-int"' + (auto ? ' role="status"' : '') + '>';
    html += '<h1 class="qz__int-h">' + heading + '</h1>';
    if (qualify && S.constellation) html += (S.useMarquee ? facesMarquee(S.constellation) : socialConstellation(S.constellation));
    if (body) html += '<p class="qz__int-body">' + body + '</p>';
    if (S.note) html += '<p class="qz__note">' + S.note + '</p>';   // citation / footnote
    if (qualify && (S.video || S.imageSrc)) {
      // product media in a premium square 1:1 frame (still image or video)
      var qmediaInner = S.video
        ? '<video class="qz-qmedia__el" autoplay muted loop playsinline preload="auto"' + (S.poster ? ' poster="' + S.poster + '"' : '') + '><source src="' + S.video + '" type="video/mp4" /></video>'
        : '<img class="qz-qmedia__el" src="' + S.imageSrc + '" alt="" />';
      html += '<div class="qz-qmedia" role="img" aria-label="' + S.image + '">' + qmediaInner + '</div>';
    } else if (qualify && S.image) {
      html += '<span class="ph ph--circle" role="img" aria-label="' + S.image + ', photo placeholder">' +
                '<span class="ph__tag" aria-hidden="true">Image</span>' +
                '<span class="ph__cap" aria-hidden="true">' + S.image + '</span></span>';
    }
    if (auto) {
      html += '<div class="qz-loader" aria-hidden="true"><span></span></div>';
      html += '<p class="qz-int__prep">' + (S.prep || 'Preparing your next question…') + '</p>';
    }
    html += '</div>';

    // Loading interstitials (auto) advance on their own — no button. Qualify (non-auto) keeps a Continue.
    if (!auto) {
      html += '<div class="qz-nav qz-nav--center">';
      html += '<button type="button" class="btn btn--lg">Continue <span class="arr" aria-hidden="true">&rarr;</span></button>';
      html += '</div>';
    }
    html += '</div>';
    stage.innerHTML = html;

    if (auto) {
      // "Preparing your next question" screen: no button, advances by itself after a fixed DELAY
      // that is IDENTICAL for every auto interstitial. Hovering pauses so it can be read; moving
      // off RESUMES the time that was left — it must NOT restart the full delay, or a screen the
      // cursor happens to rest on (e.g. the taller ones) would linger longer than the others.
      // A tap anywhere skips ahead. Advances under reduced-motion too so it is never a dead end.
      var slide = $(".qz--int", stage);
      var DELAY = S.delay || (REDUCED ? 3600 : 2600);   // per-screen override (S.delay); default otherwise
      var remaining = DELAY, startedAt = 0;
      var run  = function () { clearTimeout(advanceT); startedAt = Date.now(); advanceT = window.setTimeout(nextScreen, remaining); };
      var halt = function () { clearTimeout(advanceT); remaining = Math.max(0, remaining - (Date.now() - startedAt)); };
      run();
      slide.addEventListener("mouseenter", halt);
      slide.addEventListener("mouseleave", run);
      slide.addEventListener("click", nextScreen);
    } else {
      var go = $(".btn", stage);
      if (go) { go.addEventListener("click", nextScreen); go.focus({ preventScroll: true }); }
    }
  }

  /* ---------- results / payoff ------------------------------------------ */
  function renderResults(S, i) {
    setProgress(100);
    var headline = S.headline;   // fixed promise headline (set on the results screen config)
    var html = '<div class="qz qz--results fade-step">';
    html += '<p class="qz__lead">' + S.lead + '</p>';
    html += '<h1 class="qz__result-h">' + headline + '</h1>';
    if (S.subcopy) html += '<div class="qz-result__sub">' + S.subcopy + '</div>';
    // Results proof = the real Day 1 → Week 8–12 progression timeline (same component as the
    // sales page), on the light quiz ground.
    html += resultsTimeline();
    // Offer card — NO email gate: the CTA reveals the unlocked sales page directly.
    html += '<div class="qz-claimcard">';
    html += '<span class="qz-claimcard__deco" aria-hidden="true"></span>';
    html += '<p class="qz-claimcard__eyebrow">Exclusive Quiz Offer — Today Only</p>';
    html += '<p class="qz-claimcard__big">Buy 1, Get 1 Free</p>';
    html += '<p class="qz-claimcard__sub">on your order today</p>';
    html += '<button type="button" class="qz-claimcard__btn qz-claimcard__go">' + (S.cta || "See My Offer") + ' <span class="arr" aria-hidden="true">&rarr;</span></button>';
    html += '</div>';
    html += '</div>';
    stage.innerHTML = html;

    var go = $(".qz-claimcard__go", stage);
    if (go) go.addEventListener("click", function () {
      track("quiz_claim", { discount: DISCOUNT });
      grantOffer();     // unlock the discounted pricing
      revealSite();     // reveal the sales page
    });
    // Fill the timeline rail + light the nodes once painted (the #site reveal observer
    // doesn't watch the quiz stage, so we trigger .in ourselves).
    requestAnimationFrame(function () {
      var steps = stage.querySelectorAll(".tline__step");
      for (var k = 0; k < steps.length; k++) steps[k].classList.add("in");
    });
    track("quiz_results_view", {});
  }

  // Same 4-step progression component as the sales page, built inline for the quiz results
  // screen. No .rv (the quiz stage isn't watched by the #site reveal observer); .in is added
  // via rAF above to animate the rail.
  function resultsTimeline() {
    var steps = [
      { img: "day1.jpg?v=7",  alt: "Day 1, tired skin with visible fine lines",     ph: "Day 1",         title: "Instant hydration",                copy: "Dull, tired-looking skin with fine lines. It instantly feels nourished and hydrated." },
      { img: "wk2.jpg?v=7",   alt: "Week 2, fine lines starting to soften",          ph: "Week 2",        title: "Lines start to soften",    copy: "The look of fine lines starts to soften where they show most." },
      { img: "wk46.jpg?v=7",  alt: "Week 4 to 6, smoother, more even complexion",    ph: "Week 4–6", title: "Smoother &amp; more even", copy: "Skin looks smoother, more even and radiant." },
      { img: "wk812.jpg?v=9", alt: "Week 8 to 12, firmer, healthier-looking skin",   ph: "Week 8–12", title: "Firmer &amp; healthier",   copy: "Firmer-looking, smoother, healthier skin with continued daily use." }
    ];
    var lis = steps.map(function (s) {
      return '<li class="tline__step">' +
          '<div class="tline__img"><img src="' + window.FUNNEL_ASSET_BASE + 'funnel-timeline-' + s.img + '" alt="' + s.alt + '" width="720" height="720" loading="lazy" decoding="async" /></div>' +
          '<div class="tline__rail"><span class="tline__node"></span></div>' +
          '<span class="tline__ph">' + s.ph + '</span>' +
          '<h3 class="tline__title">' + s.title + '</h3>' +
          '<p class="tline__copy">' + s.copy + '</p>' +
        '</li>';
    }).join("");
    return '<ol class="tline tline--photos qz-tline" aria-label="Expected results over time">' + lis + '</ol>';
  }

  // Projected improvement — a coded rising bar chart mapped to REAL MONTHS (this month → +3),
  // so the payoff reads as a concrete date ("by October"), with a "Your Goal" flag on the
  // 3-month bar. Qualitative (no hard %), so it stays honest for a cosmetic; heights are
  // illustrative only. Months are computed at render so the labels are always current.
  function resultsChart() {
    var MN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var m0 = (new Date()).getMonth();
    var mo = function (k) { return MN[(m0 + k) % 12]; };
    // 5 bars: this month → +4, with the "Your Goal" flag on the 3-month bar (index 3) and one
    // month beyond it (still rising) — mirrors the reference. Month labels only, no per-bar copy.
    var H = [24, 44, 64, 82, 100];
    var GOAL = 3;
    var cols = H.map(function (h, k) {
      var goal = k === GOAL ? " qz-bar__col--goal" : "";
      var flag = k === GOAL ? '<span class="qz-bar__flag">Your Goal</span>' : "";
      return '<div class="qz-bar__col' + goal + '">' +
               '<div class="qz-bar__track">' + flag +
                 '<div class="qz-bar__fill" style="height:' + h + '%; animation-delay:' + (0.06 + k * 0.11).toFixed(2) + 's"></div>' +
               '</div>' +
               '<span class="qz-bar__when">' + mo(k) + '</span>' +
             '</div>';
    }).join("");
    return '<figure class="qz-chart">' +
        '<div class="qz-bars">' + cols + '</div>' +
      '</figure>';
  }

  // Email gate cleared: grant the offer + reveal the sales page in its unlocked state.
  // (The custom-plan screen S15 is parked; when re-enabled, swap revealSite() → nextScreen().)
  function claimDiscount() {
    track("quiz_claim", { discount: DISCOUNT });
    grantOffer();
    revealSite();
  }

  /* ---------- custom plan (S15) ----------------------------------------- *
   * The MiamiMD-style "custom plan": maps the personalized goal to real months, then offers
   * jar-count tiers where the 3-month (3-jar) course is the recommended best value. Kept on the
   * quiet-luxury quiz brand (monochrome ink on bone, one ink accent). Prices reuse the reconciled
   * constants; the 3-jar total is PRICE_THREE (proposed). Shown AFTER the email gate, so the
   * signup stays guarded and the unlocked price is what the shopper sees here. */
  function renderPlan(S, i) {
    setProgress(100);
    var r = RESULT[leadPain()];
    var headline = (r && r.headline) ? r.headline : S.headline;
    var goal     = (r && r.lead)     ? r.lead     : "Firmer, smoother, younger-looking skin";

    var STEPS = [
      { m: "Month 1", t: "Hydrated, calmer, more radiant-looking skin" },
      { m: "Month 2", t: "Smoother texture, softer-looking fine lines" },
      { m: "Month 3", t: goal, goal: true }
    ];
    var TIERS = [
      { key: "m1", months: 1, jars: 1, total: PRICE_DISC,  per: PRICE_DISC, ship: "" },
      { key: "m2", months: 2, jars: 2, total: PRICE_TWO,   per: 50.00,      ship: "Free shipping" },
      { key: "m3", months: 3, jars: 3, total: PRICE_THREE, per: 44.99,      ship: "Free shipping", best: true }
    ];

    var html = '<div class="qz qz--plan fade-step">';
    html += '<p class="qz__lead">' + S.lead + '</p>';
    html += '<h1 class="qz__result-h">' + headline + '</h1>';
    html += '<p class="qz-plan__intro">Here’s the month-by-month plan we’d build for your skin — and the supply to see it all the way through.</p>';

    // month-by-month goal timeline
    html += '<ol class="qz-tl">';
    STEPS.forEach(function (s, k) {
      html += '<li class="qz-tl__step' + (s.goal ? ' qz-tl__step--goal' : '') + '">' +
                '<span class="qz-tl__dot" aria-hidden="true">' + (k + 1) + '</span>' +
                '<span class="qz-tl__body"><span class="qz-tl__m">' + s.m + '</span>' +
                '<span class="qz-tl__t">' + s.t + '</span></span>' +
              '</li>';
    });
    html += '</ol>';

    // jar/month plan tiers (3-month recommended + pre-selected)
    html += '<div class="qz-plans" role="radiogroup" aria-label="Choose your plan">';
    TIERS.forEach(function (t) {
      var sel = !!t.best;
      var save = PRICE_FULL * t.jars - t.total;
      html += '<button type="button" class="qz-plan' + (sel ? ' is-sel' : '') + (t.best ? ' qz-plan--best' : '') +
                '" data-plan="' + t.key + '" data-months="' + t.months + '" role="radio" aria-checked="' + sel + '">';
      if (t.best) html += '<span class="qz-plan__tag">Recommended</span>';
      html += '<span class="qz-plan__head"><span class="qz-plan__mo">' + t.months + ' Month' + (t.months > 1 ? 's' : '') + '</span>' +
              '<span class="qz-plan__jars">' + t.jars + ' jar' + (t.jars > 1 ? 's' : '') + '</span></span>';
      html += '<span class="qz-plan__price">' + money(t.total) + '</span>';
      html += '<span class="qz-plan__per">' + (t.jars > 1 ? money(t.per) + ' / jar' : 'One-time') + '</span>';
      html += '<span class="qz-plan__save">' + (save >= 1 ? 'Save $' + Math.round(save) : '') +
              (t.ship ? (save >= 1 ? ' · ' : '') + t.ship : '') + '</span>';
      html += '<span class="qz-plan__tick" aria-hidden="true"></span>';
      html += '</button>';
    });
    html += '</div>';

    html += '<button type="button" class="btn btn--lg qz-plan__cta"></button>';
    html += '<p class="qz-plan__fine">30-day money-back guarantee · Cancel anytime · Your unlocked price is reserved for today.</p>';
    html += '</div>';
    stage.innerHTML = html;

    var cards = $$(".qz-plan", stage);
    var cta   = $(".qz-plan__cta", stage);
    var chosen = "m3";
    function label() {
      var t = TIERS.filter(function (x) { return x.key === chosen; })[0];
      var n = t ? t.months : 3;
      cta.innerHTML = 'Start My ' + n + '-Month Plan <span class="arr" aria-hidden="true">&rarr;</span>';
    }
    cards.forEach(function (c) {
      c.addEventListener("click", function () {
        chosen = c.getAttribute("data-plan");
        cards.forEach(function (x) {
          var on = x === c;
          x.classList.toggle("is-sel", on);
          x.setAttribute("aria-checked", on ? "true" : "false");
        });
        label();
      });
    });
    label();
    if (cta) cta.addEventListener("click", function () { track("quiz_plan_select", { plan: chosen }); revealSite(); });
    track("quiz_plan_view", {});
  }

  /* ---------- offer / pricing ------------------------------------------ */
  function injectUnlock() {
    var card = $(".offer__card");
    if (card && !$(".offer__unlock")) {
      var box = document.createElement("div");
      box.className = "only-noffer offer__unlock";
      box.innerHTML = '<p>Take the 1-minute skin quiz to unlock a <b>free jar</b> — buy one, get one free.</p>' +
        '<button class="btn" id="offerReopen" type="button">Take the 1-minute quiz ' +
        '<span class="arr" aria-hidden="true">&rarr;</span></button>';
      card.insertBefore(box, card.querySelector(".offer__price"));
      $("#offerReopen").addEventListener("click", reopenQuiz);
    }
  }

  function storedStart() { try { return parseInt(localStorage.getItem(LS.start) || "0", 10); } catch (e) { return 0; } }
  function remaining() { var s = storedStart(); return s ? (OFFER_MINUTES * 60 - (Date.now() - s) / 1000) : 0; }

  // grant on quiz completion — never resets an existing hold (no re-trigger loophole)
  function grantOffer() {
    var s = storedStart();
    if (!s) { s = Date.now(); try { localStorage.setItem(LS.start, String(s)); } catch (e) {} }
    try { localStorage.setItem(LS.done, "1"); } catch (e) {}
    saveAnswers();
    track("offer_unlocked", { code: FREE_JAR_CODE, deal: "buy1get1" });
    resumeOffer();
  }
  function resumeOffer() {
    // expiry is checked from the stored timestamp on each load; a calm live countdown runs while valid
    var on = remaining() > 0;
    setOffer(on);
    if (on) tickCountdown();
  }

  function tickTimer(r) {
    clearInterval(timerInt);
    var end = Date.now() + r * 1000;
    var paint = function () {
      var sec = Math.round((end - Date.now()) / 1000);
      if (sec <= 0) { clearInterval(timerInt); setOffer(false); return; }
      var mm = Math.floor(sec / 60), ss = sec % 60;
      $$(".tmr").forEach(function (t) { t.textContent = pad(mm) + ":" + pad(ss); });
    };
    paint();
    timerInt = setInterval(paint, 1000);
  }

  function setOffer(on) {
    offerActive = on;
    var wasDone = false; try { wasDone = localStorage.getItem(LS.done) === "1"; } catch (e) {}
    document.body.classList.toggle("offer-on", on);
    document.body.classList.toggle("offer-off", !on);
    document.body.classList.toggle("offer-expired", !on && wasDone);   // ran out of time (vs never unlocked)
    var offerSec = $("#offer"); if (offerSec) offerSec.classList.toggle("expired", !on);
    if (!on) clearInterval(timerInt);
    render();
  }

  // discount expired → recovery: re-grant a fresh reserve and re-activate the offer
  function wireRecover() {
    var rec = $("#offerRecover");
    if (!rec) return;
    rec.addEventListener("click", function () {
      try { localStorage.setItem(LS.start, String(Date.now())); } catch (e) {}
      resumeOffer();
      track("discount_recovered", {});
      var o = $("#offer"); if (o) o.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
    });
  }

  function render() {
    // The offer's own tier prices live in the shared buy module (renderBuy). render() only
    // drives the secondary "as low as $X/jar" echoes (anchor cell + sticky bar).
    var perJarFloor = Math.round(PRICE_FULL / 2 * 100) / 100;   // Buy-1-Get-1 effective = $40.00/jar
    $$(".plan-sub-price").forEach(function (el) { el.textContent = money(perJarFloor); });
    $$(".px-was").forEach(function (el) { el.textContent = money(PRICE_FULL); });
    $$(".per-day").forEach(function (el) { el.textContent = "$" + (Math.round(perJarFloor / 38 * 100) / 100).toFixed(2); });
  }

  function reopenQuiz() {
    answers = {};
    screenIndex = 0;
    $("#site").setAttribute("hidden", "");
    var sb = $("#stickybar"); sb.setAttribute("hidden", ""); sb.classList.remove("show");
    $("#quiz").removeAttribute("hidden");
    window.scrollTo(0, 0);
    renderScreen(0);
  }

  /* ---------- quiz-answer persistence + sales-page personalization ------ */
  function saveAnswers() {
    try { if (answers && Object.keys(answers).length) localStorage.setItem(LS.answers, JSON.stringify(answers)); } catch (e) {}
  }
  function loadAnswers() {
    if (answers && Object.keys(answers).length) return answers;
    try { return JSON.parse(localStorage.getItem(LS.answers) || "{}"); } catch (e) { return {}; }
  }
  // Sales-page personalization, keyed by the S3 "pain" answer (hedged, product-truth only).
  var MATCH = {
    "dark-circles": { match: "a brighter, fresher eye area",
      why: "You told us the eye area is what you'd change first. It's the most delicate skin on the face, so Crème Régénérante pairs niacinamide for a brighter, more even look with peptides and deep hydration, to leave it looking smoother and more rested." },
    "texture": { match: "smoother, more even-looking skin",
      why: "You told us dull, uneven texture bothers you most. Peptides and lasting hydration help refine the look of texture, while niacinamide supports a more even, radiant-looking finish." },
    "dryness": { match: "calmer, deeply hydrated skin",
      why: "You told us dry, tight skin is your priority. This is a gentle, deeply hydrating formula: sodium hyaluronate and panthenol help skin feel calm, cushioned and comfortable all day." },
    "lines": { match: "softer-looking fine lines",
      why: "You told us fine lines are what you notice most. VYPR-2™ is built to soften their look while helping delay how new ones form, and to firm and smooth the look of the skin around them." }
  };
  function personalizeSite() {
    var a = loadAnswers();
    var m = a && a.pain ? MATCH[a.pain] : null;
    if (!m) return;
    var badge = $(".hero__matched");
    if (badge) { var svg = badge.querySelector("svg"); badge.innerHTML = (svg ? svg.outerHTML : "") + " Your match for " + m.match; }
    var body = $("#matchBody"), sec = $("#matchWhy");
    if (body && sec) { body.textContent = m.why; sec.removeAttribute("hidden"); }
  }
  // Calm 24h countdown on the reserved deal (reads the stored start; honest across reloads).
  function tickCountdown() {
    clearInterval(timerInt);
    var paint = function () {
      var sec = Math.round(remaining());
      if (sec <= 0) { clearInterval(timerInt); setOffer(false); return; }
      var m = Math.floor(sec / 60), s = sec % 60;   // mm:ss (max 60 min)
      $$(".tmr").forEach(function (t) { t.textContent = pad(m) + ":" + pad(s); });
    };
    paint();
    timerInt = setInterval(paint, 1000);
  }

  /* ---------- reveal the sales page ------------------------------------ */
  function revealSite() {
    $("#quiz").setAttribute("hidden", "");
    $("#site").removeAttribute("hidden");
    $("#stickybar").removeAttribute("hidden");
    document.body.classList.add("quiz-done");   // unlocks the "personalized match" chip
    personalizeSite();                          // echo the shopper's quiz answers into the page
    window.scrollTo(0, 0);
    setupReveal();
    requestAnimationFrame(function () { _centerUgc && _centerUgc(); });
    track("page_reached", { via: "quiz", offer: offerActive });
  }
  function showSiteDirect(withOffer) {
    $("#quiz").setAttribute("hidden", "");
    $("#site").removeAttribute("hidden");
    $("#stickybar").removeAttribute("hidden");
    if (withOffer) { resumeOffer(); document.body.classList.add("quiz-done"); personalizeSite(); }
    else setOffer(false);
    setupReveal();
    requestAnimationFrame(function () { _centerUgc && _centerUgc(); });
    track("page_reached", { via: withOffer ? "returning" : "skip", offer: offerActive });
  }

  /* ---------- scroll reveal -------------------------------------------- */
  var revObserver = null;
  function setupReveal() {
    if (!("IntersectionObserver" in window)) { $$(".rv").forEach(function (e) { e.classList.add("in"); }); return; }
    if (!revObserver) {
      revObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); revObserver.unobserve(en.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    }
    $$("#site .rv").forEach(function (el) { if (!el.classList.contains("in")) revObserver.observe(el); });
  }

  /* ---------- before / after slider ------------------------------------ */
  function wireBA() {
    var s = $("#baSlider"), h = $("#baHandle"); if (!s || !h) return;
    function setPos(p) { p = Math.max(0, Math.min(100, p)); s.style.setProperty("--pos", p + "%"); h.setAttribute("aria-valuenow", Math.round(p)); }
    function fromX(x) { var r = s.getBoundingClientRect(); setPos((x - r.left) / r.width * 100); }
    var drag = false;
    s.addEventListener("pointerdown", function (e) { drag = true; try { s.setPointerCapture(e.pointerId); } catch (x) {} fromX(e.clientX); });
    s.addEventListener("pointermove", function (e) { if (drag) fromX(e.clientX); });
    window.addEventListener("pointerup", function () { drag = false; });
    h.addEventListener("keydown", function (e) {
      var cur = parseFloat(h.getAttribute("aria-valuenow")) || 50;
      if (e.key === "ArrowLeft") { setPos(cur - 4); e.preventDefault(); }
      if (e.key === "ArrowRight") { setPos(cur + 4); e.preventDefault(); }
    });
    setPos(50);
  }

  /* ---------- UGC video ------------------------------------------------- */
  function wireVideo() {
    var v = $("#ugcVideo"), p = $("#ugcPlay"); if (!v || !p) return;
    p.addEventListener("click", function () {
      v.muted = false;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); });
      p.setAttribute("hidden", "");
    });
  }

  /* ---------- UGC carousel (center hero, swipe sides) ------------------- */
  var _centerUgc = null;
  function wireUgcCarousel() {
    var track = $("#ugcTrack"), hero = $("#ugcMain");
    if (!track || !hero) return;
    function centerHero() {
      if (!track.clientWidth) return false;
      var left = hero.offsetLeft - (track.clientWidth - hero.clientWidth) / 2;
      var sb = track.style.scrollBehavior; track.style.scrollBehavior = "auto"; // instant, no animated jump
      track.scrollLeft = left;
      track.style.scrollBehavior = sb;
      return true;
    }
    _centerUgc = centerHero;
    // fallback: center the first time the carousel scrolls into view
    var done = false;
    function tryCenter() { if (!done && centerHero()) done = true; }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { tryCenter(); if (done) io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(track);
    }
    window.addEventListener("resize", function () { centerHero(); });
    var step = function () {
      var clip = track.querySelector(".ugc__clip");
      return (clip ? clip.getBoundingClientRect().width : 200) + 18;
    };
    var prev = $("#ugcPrev"), next = $("#ugcNext");
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  }

  /* ---------- nav + sticky + faq + buy --------------------------------- */
  function wireChrome() {
    var nav = $("#nav"), sticky = $("#stickybar");
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (nav) nav.classList.toggle("solid", y > 40);
      if (sticky && !sticky.hasAttribute("hidden")) {
        var past = y > (window.innerHeight * 0.85);
        var nearOffer = false, nearFoot = false, offer = $("#offer"), foot = $(".foot");
        if (offer) { var r = offer.getBoundingClientRect(); nearOffer = r.top < window.innerHeight && r.bottom > 0; }
        if (foot) nearFoot = foot.getBoundingClientRect().top < window.innerHeight;
        sticky.classList.toggle("show", past && !nearOffer && !nearFoot);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    $$(".qa__q").forEach(function (q) {
      q.addEventListener("click", function () {
        var qa = q.parentElement, open = qa.classList.toggle("open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) track("faq_open", { q: (q.textContent || "").trim().slice(0, 60) });
      });
    });

    $$(".js-buy").forEach(function (b) {
      b.addEventListener("click", function (e) {
        if (b.getAttribute("href") === "#") { e.preventDefault(); funnelCheckout(); }
      });
    });
    // Hero "Add to Cart": add the selected set and take the shopper straight to checkout (not the cart page, not a scroll to the offer)
    var heroBtn = document.getElementById("heroCta");
    if (heroBtn) heroBtn.addEventListener("click", function (e) { e.preventDefault(); funnelCheckout('/checkout'); });
  }


  var toastT = null;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("show"); }, 4600);
  }

  /* ---------- exit-intent (desktop, once per session) ------------------- */
  function wireExitIntent() {
    var modal = $("#xintent"); if (!modal) return;
    var armed = true;
    function open() {
      if (!armed) return;
      if ($("#site").hasAttribute("hidden")) return;            // only on the sales page
      try { if (sessionStorage.getItem("synera_xintent") === "1") return; } catch (e) {}
      armed = false; try { sessionStorage.setItem("synera_xintent", "1"); } catch (e) {}
      var hasLead = false; try { hasLead = !!localStorage.getItem(LS.lead); } catch (e) {}
      var fine = modal.querySelector(".xintent__fine");
      if (hasLead) {
        $("#xintentForm").style.display = "none"; $("#xToOffer").style.display = ""; if (fine) fine.style.display = "none";
        $("#xText").innerHTML = "Your free jar is reserved for you today. Pick up right where you left off.";
      } else {
        $("#xintentForm").style.display = ""; $("#xToOffer").style.display = "none"; if (fine) fine.style.display = "";
        $("#xText").innerHTML = "Your free jar is reserved — buy one, get one free. We'll send the deal to your inbox so you don't lose it.";
      }
      modal.removeAttribute("hidden");
      requestAnimationFrame(function () { modal.classList.add("show"); });
      track("exit_intent_shown", { hasLead: hasLead });
      var inp = $("#xEmail"); if (inp && !hasLead) setTimeout(function () { inp.focus(); }, 160);
    }
    function close() { modal.classList.remove("show"); setTimeout(function () { modal.setAttribute("hidden", ""); }, 320); }
    document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    $("#xClose").addEventListener("click", function () { close(); track("exit_intent_dismiss", {}); });
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("show")) close(); });
    $("#xintentForm").addEventListener("submit", function (e) {
      e.preventDefault();
      var inp = $("#xEmail"), v = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { inp.classList.add("err"); inp.focus(); return; }
      inp.classList.remove("err");
      saveLead(v); grantOffer(); track("exit_intent_lead", {});
      close(); var o = $("#offer"); if (o) o.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
    });
    $("#xToOffer").addEventListener("click", function () {
      close(); var o = $("#offer"); if (o) o.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
      track("exit_intent_to_offer", {});
    });
  }

  function saveLead(email) {
    try { localStorage.setItem(LS.lead, JSON.stringify({ email: email, answers: answers, at: Date.now() })); } catch (e) {}
    track("lead_captured", { age: answers.age });   // no PII to analytics
    // Capture the lead in Klaviyo (client-side subscribe to the Email List — verified 202)
    try {
      var _concern = (typeof leadPain === "function") ? leadPain() : "";
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=Y5YDRA", {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: {
          custom_source: "Firming Match Quiz - Exit Intent",
          profile: { data: { type: "profile", attributes: {
            email: email,
            properties: { "Quiz Age": (answers.age || ""), "Quiz Concern": _concern, "Lead Source": "Firming Match Quiz" }
          } } }
        }, relationships: { list: { data: { type: "list", id: "UZvEXk" } } } } })
      }).catch(function(){});
    } catch (e) {}
  }

  // Buy module — the hero AND the final offer share ONE picker + ONE state (heroMode/heroSel).
  // heroSel = the PAID quantity N (1/2/3). One-time = Buy N Get N Free (2N jars, pay N×$79.99).
  // Subscribe = N jars at 10% off (Appstle plan). renderBuy() paints #heroTiers + #offerTiers.
  var HERO_TIERS = [
    { n: 1, img: (window.FUNNEL_ASSET_BASE+"funnel-set-2.jpg"), tag: "Most chosen" },
    { n: 2, img: (window.FUNNEL_ASSET_BASE+"funnel-set-4.jpg") },
    { n: 3, img: (window.FUNNEL_ASSET_BASE+"funnel-set-6.jpg"), tag: "Best value" }
  ];
  var heroMode = "single", heroSel = 1;   // default: Buy 1, Get 1 Free (push entry offer)
  function heroPrice(t) {
    var n = t.n;
    if (heroMode === "subscribe") {
      var perS = Math.round(PRICE_FULL * SUB_MULT * 100) / 100;        // $71.99/jar
      return { mode:'subscribe', paid:n, jars:2*n, free:n, per:perS,
               total: Math.round(perS * n * 100) / 100,
               save:  Math.round(2*n * PRICE_FULL * 100) / 100 };
    }
    var total = Math.round(PRICE_FULL * n * 100) / 100;               // pay full price for N jars
    return { mode:'onetime', paid:n, jars:2*n, free:n,
             per:  Math.round(total / (2*n) * 100) / 100,              // effective per-jar (~$40)
             total: total,
             save:  Math.round(PRICE_FULL * n * 100) / 100 };          // value of the free jars
  }
  function tierRowsHTML() {
    return HERO_TIERS.map(function (t) {
      var d = heroPrice(t), on = t.n === heroSel, title, note, saveLine;
      if (d.mode === 'subscribe') {
        title = 'Buy ' + t.n + ', Get ' + t.n + ' Free';
        note  = 'Subscribe · save 10%';
        saveLine = '$' + (Math.round(d.jars * PRICE_FULL * 100) / 100).toFixed(2) + ' VALUE';
      } else {
        title = 'Buy ' + t.n + ', Get ' + t.n + ' Free';
        note  = '';
        saveLine = '$' + (Math.round(d.jars * PRICE_FULL * 100) / 100).toFixed(2) + ' VALUE';
      }
      return '<button type="button" class="tier' + (on ? ' is-sel' : '') + '" data-n="' + t.n +
               '" role="radio" aria-checked="' + on + '">' +
               '<img class="tier__img" src="' + t.img + '" alt="" width="104" height="104" loading="lazy" />' +
               '<span class="tier__id">' +
                 '<span class="tier__jars">' + title +
                   (t.tag ? ' <em class="tier__tag">' + t.tag + '</em>' : '') + '</span>' +
                 (note ? '<span class="tier__note">' + note + '</span>' : '') +
               '</span>' +
               '<span class="tier__money"><span class="tier__per">' + money(d.total) + '</span>' +
                 '<span class="tier__save" style="font-size:13px;font-weight:800;">' + saveLine + '</span></span>' +
             '</button>';
    }).join("");
  }
  // Paint tiers into every buy container, sync every mode toggle, and update both CTAs + per-day lines.
  function renderBuy() {
    var rows = tierRowsHTML();
    ["heroTiers", "offerTiers"].forEach(function (id) {
      var box = document.getElementById(id); if (box) box.innerHTML = rows;
    });
    $$(".buymode").forEach(function (m) {
      var on = m.getAttribute("data-mode") === heroMode;
      m.classList.toggle("is-on", on);
      m.setAttribute("aria-selected", on ? "true" : "false");
    });
    var sel = HERO_TIERS.filter(function (x) { return x.n === heroSel; })[0];
    if (!sel) return;
    var d = heroPrice(sel), total = money(d.total);
    var ctaLabel = (d.mode === 'subscribe') ? 'Subscribe &amp; Save' : ('Get My Free Jar' + (sel.n > 1 ? 's' : ''));
    document.querySelectorAll('.hero__discount').forEach(function(el){ el.innerHTML = (d.mode === 'subscribe') ? '&#10022; <b>Free jars ship with your first order</b> &mdash; your plan then renews at 10% off.' : '&#10022; <b>You unlocked a free jar</b> &mdash; every jar you buy comes with one free.'; });
    var hc = document.getElementById("heroCta");
    if (hc) hc.innerHTML = ctaLabel + ' <span class="buy__ctaprice">' + total +
      '</span> <span class="arr" aria-hidden="true">&rarr;</span>';
    var oc = document.getElementById("offerCta");
    if (oc) oc.innerHTML = ctaLabel + ' <span class="buy__ctaprice">' + total +
      '</span> <span class="arr" aria-hidden="true">&rarr;</span>';
    // "Only $X a day" — effective per-jar of the SELECTED tier over a 30-day jar (one jar = 30-day supply).
    var pd = money(Math.round(d.per / 30 * 100) / 100);
    ["heroPerDay", "offerPerDay"].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.textContent = pd;
    });
  }
  function wireBuy() {
    renderBuy();
    ["heroTiers", "offerTiers"].forEach(function (id) {
      var box = document.getElementById(id); if (!box) return;
      box.addEventListener("click", function (e) {
        var b = e.target.closest(".tier"); if (!b) return;
        heroSel = parseInt(b.getAttribute("data-n"), 10);
        track("plan_select", { paid: heroSel, mode: heroMode });
        renderBuy();
      });
    });
    $$(".buymode").forEach(function (m) {
      m.addEventListener("click", function () {
        heroMode = m.getAttribute("data-mode");
        renderBuy();
      });
    });
  }

  /* ---------- boot ------------------------------------------------------ */
  function init() {
    injectUnlock();
    wireChrome();
    wireBuy();
    wireRecover();
    wireBA();
    wireVideo();
    wireUgcCarousel();
    wireExitIntent();

    var done = false; try { done = localStorage.getItem(LS.done) === "1"; } catch (e) {}
    if (done && location.hash !== "#quiz") showSiteDirect(true);
    else { track("quiz_start", {}); renderScreen(0); }
    render();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
